// extracted by mini-css-extract-plugin
export default {"email":"email_email__2A1-W","emailInner":"email_emailInner__i-52G","heading":"email_heading__idl+i"};